import session from '@/shared/session'

const initialState = () => ({
	patient: {
		diagnostics: []
	},

	diagnostic_types: [],
})

const state = initialState()

// getters
const getters = {
	getPatientDiagnostics: (state) => () => {
		return state.patient.diagnostics
	}
}

// actions
const actions = {
	async resetState ({ commit }) {
		commit('reset_state')
	},

	async filterDiagnosticsTests({ commit, state }, params) {
		const items = await session
			.get('/api/catalogue/referral_tests/', {
					params: params
			})

		return items.data
	},

	async getDiagnosticsForCurrentPatient({ commit, state, rootState, dispatch }) {
		if (!rootState.patients.current) {
			return
		}

		dispatch("loading/load", "lab", { root: true })

		const diagnostics  = await session
			.get(`/api/patients/${rootState.patients.current?.id}/lab/`)

		commit("set_diagnostics", diagnostics.data)

		dispatch("loading/end", "lab", { root: true })

		return state.patient.diagnostics
	},

	async getLabChartDataForCurrentPatient({ commit, state, rootState, dispatch }) {
		if (!rootState.patients.current) {
			return
		}

		dispatch("loading/load", "lab_chart", { root: true })

		const chart  = await session
			.get(`/api/patients/${rootState.patients.current?.id}/lab_chart/`)

		dispatch("loading/end", "lab_chart", { root: true })

		return chart.data
	},

	async filterDiagnosticsTemplates({ commit, state }, params) {
		const templates = await session
			.get('/api/lab/templates/', {
					params: params
			})

		return templates.data
	},

	createDiagnosticsTemplate({ dispatch, commit, rootState }, data) {
		dispatch("loading/load", "lab_template", { root: true })
		return session
				.post(`/api/lab/templates/`, data)
				.then((template) => {
					return template.data
				})
	      .finally(() => {
	        dispatch("loading/end", "lab_template", { root: true })
	      })
	},

	updateDiagnosticsTemplate({ commit, dispatch }, { id , data }) {
    dispatch("loading/load", "test_template", { root: true })
		return session
			.put(`/api/lab/templates/${id}/`, data)
			.then((template) => {
					return template.data
			})
			.finally(() => {
				dispatch("loading/end", "test_template", { root: true })
			})
	},

	deleteDiagnosticsTemplate({ dispatch }, id) {
		dispatch("loading/load", "lab_template", { root: true })
		return session
				.delete(`/api/lab/templates/${id}/`)
				.then(() => {
					return dispatch("getDiagnosticsTemplates")
				})
      .finally(() => {
        dispatch("loading/end", "lab_template", { root: true })
      })
	},

	createDiagnostics({ dispatch, commit, rootState }, data) {
		dispatch("loading/load", "lab", { root: true })
		return session
				.post(`/api/lab/`, {...data, decursus: rootState.decursus.current?.id})
				.then(() => {
					return dispatch("getDiagnosticsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "lab", { root: true })
	      })
	},

	createPatientAdminDiagnostics({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "lab", { root: true })
		return session
				.post(`/api/patients/administration/${rootState.patients.current?.id}/diagnostics/`, data)
				.then(() => {
					return dispatch("getDiagnosticsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "lab", { root: true })
	      })
	},

	deleteDiagnostics({ dispatch }, id) {
		dispatch("loading/load", "lab", { root: true })
		return session
				.delete(`/api/lab/${id}/`)
				.then(() => {
					return dispatch("getDiagnosticsForCurrentPatient")
				})
      .finally(() => {
        dispatch("loading/end", "lab", { root: true })
      })
	},

	uploadLabDocument({ commit, dispatch }, {id, data}) {


    dispatch("loading/load", `document_${id}`, { root: true })
		return session
			.post(`/api/lab/${id}/document/`, data)
			.then((lab) => {
				return dispatch("getDiagnosticsForCurrentPatient")
			})
			.finally(() => {
				dispatch("loading/end", `document_${id}`, { root: true })
			})
	},

	deleteLabDocument({ commit, dispatch }, id) {
    	dispatch("loading/load", `document_${id}`, { root: true })
		return session
			.patch(`/api/lab/${id}/delete_document/`)
			.then((lab) => {
				return dispatch("getDiagnosticsForCurrentPatient")
			})
			.finally(() => {
				dispatch("loading/end", `document_${id}`, { root: true })
			})
	},

	updateDiagnosticTest({ commit, dispatch }, { id, data }) {
    dispatch("loading/load", `lab_test_${id}`, { root: true })
		return session
			.put(`/api/lab/tests/${id}/`, data)
			.then((test) => {
				dispatch("getDiagnosticsForCurrentPatient")
				return test.data
			})
			.finally(() => {
				dispatch("loading/end", `lab_test_${id}`, { root: true })
			})
	},
	diagnosticReferralsReport({ commit, state }) {
		return session
				.get(`/api/lab/year_report/`)
				.then(results => {
					return results.data
				})
	},
	diagnosticReferralsTotalReport({ commit, state }) {
		return session
				.get(`/api/lab/total_report/`)
				.then(results => {
					return results.data
				})
	},
	diagnosticReferralsYearReport({ commit, state }, year) {
		return session
				.get(`/api/lab/year_report/${year}/`,)
				.then(results => {
					return results.data
				})
	},
	diagnosticReferralsMonthReport({ commit, state }, data) {
		return session
				.get(`/api/lab/month_report/${data['month']}/${data['year']}/`,)
				.then(results => {
					return results.data
				})
	},
	diagnosticReferralsTestMonthReport({ commit, state }, data) {
		let url = ""
		if (data['params']){
			url = `/api/lab/tests/month_report/${data['month']}/${data['year']}/?${data['params']}`

		} else {
			url = `/api/lab/tests/month_report/${data['month']}/${data['year']}/`

		}
		return session
				.get(url,)
				.then(results => {
					return results.data
				})
	},
	diagnosticReferralsTestMonthTotalReport({ commit, state }, data) {
		return session
				.get(`/api/lab/tests/month_report/tests/${data['month']}/${data['year']}/`,)
				.then(results => {
					return results.data
				})
	},
}

// mutations
const mutations = {
  reset_state(state) {
		Object.assign(state, initialState())
  },
  
	set_diagnostics(state, diagnostics) {
		state.patient.diagnostics = diagnostics
	},
	set_diagnostic_types(state, types) {
		state.diagnostic_types = types
	},
	set_lab_chart_data(state, chart_data) {
		state.patient.lab_chart_data = chart_data
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}